export const COLORS = ['#1D9E75','#D85A30','#7F77DD','#378ADD','#BA7517','#D4537E'];
export const AVATAR_BG = ['#E1F5EE','#FAECE7','#EEEDFE','#E6F1FB','#FAEEDA','#FBEAF0'];
export const AVATAR_TEXT = ['#0F6E56','#993C1D','#534AB7','#185FA5','#854F0B','#993556'];

export const CATS = [
  { id: 'food', icon: '🍽️', label: 'Food' },
  { id: 'transport', icon: '🚗', label: 'Travel' },
  { id: 'home', icon: '🏠', label: 'Home' },
  { id: 'entertainment', icon: '🎬', label: 'Fun' },
  { id: 'shopping', icon: '🛍️', label: 'Shop' },
  { id: 'utilities', icon: '⚡', label: 'Bills' },
  { id: 'health', icon: '💊', label: 'Health' },
  { id: 'other', icon: '📦', label: 'Other' },
];

export const fmt = (n) => '$' + Math.abs(n).toFixed(2);

export function getCat(id) {
  return CATS.find(c => c.id === id) || CATS[7];
}

export function Avatar({ person, size = 28 }) {
  const initials = person.name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2);
  const bg = AVATAR_BG[person.color % AVATAR_BG.length];
  const color = AVATAR_TEXT[person.color % AVATAR_TEXT.length];
  return (
    <div className="avatar" style={{ width: size, height: size, background: bg, color }}>
      {initials}
    </div>
  );
}
